import { render, staticRenderFns } from "./CountdownBtn.vue?vue&type=template&id=32edc400&scoped=true"
import script from "./CountdownBtn.vue?vue&type=script&lang=js"
export * from "./CountdownBtn.vue?vue&type=script&lang=js"
import style0 from "./CountdownBtn.vue?vue&type=style&index=0&id=32edc400&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32edc400",
  null
  
)

export default component.exports